export class Constants {
    public static readonly Authority = 'https://sso-dev.shell.com';
    public static readonly clientId = 'xjFAXLRxe1ofsvvk';
    public static readonly clientRoot = 'https://transhubdev.shell.com/';
    public static readonly clientScope = 'openid profile';
    public static readonly clientSecret = '';
    public static readonly maxFileSizeInBytes = 5242880;
    public static readonly helpSupportURL = 'https://eu001-sp.shell.com/sites/AAFAA3645/Global%20Commercials%20%20%20Chemicals%20Projects/Forms/AllItems.aspx?id=%2Fsites%2FAAFAA3645%2FGlobal%20Commercials%20%20%20Chemicals%20Projects%2F2023%20Projects%2FAviation%2FPGM0027134%20SAV%20Digital%20Operations%20Transformation%2FPRJ3232526%20SAV%20DOT%20OneHub%20Replacement%20Application%2FReference%20Materials&viewid=1731a413%2Dee30%2D47fb%2D99f5%2Dfce9b023c53d';
}
